<template>
  <transition name="modal-fade">
    <div v-if="value" class="modal-overlay" @click.self="$emit('input', false)">
      <div class="modal-container" @click.stop="resetInactivityTimer">
        <!-- Header -->
        <div class="modal-header">
          <div class="modal-header__eyebrow">
            <span class="modal-brand">Photo Now</span>
            <span class="modal-sep"></span>
            <span class="modal-tag">Documento Legal</span>
          </div>
          <h1 class="modal-title">Política de Privacidade</h1>
          <p class="modal-meta">Última atualização: março de 2026 · LGPD</p>
          <button class="modal-close" @click="$emit('input', false)">
            <v-icon color="#4a403a" size="28">mdi-close</v-icon>
          </button>
        </div>

        <!-- Body scrollável -->
        <div class="modal-body">
          <!-- 01 -->
          <article class="pp-section">
            <span class="pp-num">01</span>
            <div class="pp-body">
              <h2 class="pp-title">Coleta de dados</h2>
              <p class="pp-text">
                Coletamos <strong>imagens enviadas pelo usuário</strong> no
                momento da utilização dos totens, bem como
                <strong>dados de contato</strong> (como número de telefone)
                quando informados voluntariamente pelo usuário ao final da
                utilização.
              </p>
            </div>
          </article>

          <!-- 02 -->
          <article class="pp-section">
            <span class="pp-num">02</span>
            <div class="pp-body">
              <h2 class="pp-title">Uso das informações</h2>
              <p class="pp-text">
                As imagens são utilizadas exclusivamente para:
              </p>
              <ul class="pp-list">
                <li>Execução do serviço de impressão das fotos solicitadas</li>
              </ul>
              <p class="pp-text pp-text--mt">
                Os dados de contato fornecidos de forma voluntária poderão ser
                utilizados para:
              </p>
              <ul class="pp-list">
                <li>
                  Envio de cupons, ofertas e comunicações promocionais via
                  WhatsApp
                </li>
              </ul>
            </div>
          </article>

          <!-- 03 -->
          <article class="pp-section">
            <span class="pp-num">03</span>
            <div class="pp-body">
              <h2 class="pp-title">Base legal para tratamento</h2>
              <p class="pp-text">
                O tratamento de dados pessoais é realizado com base na
                <strong>Lei Geral de Proteção de Dados Pessoais (LGPD)</strong>,
                considerando:
              </p>
              <div class="pp-cards">
                <div class="pp-card">
                  <p class="pp-card__label">Execução de contrato</p>
                  <p class="pp-card__desc">
                    Para viabilizar a impressão das fotos solicitadas
                  </p>
                </div>
                <div class="pp-card">
                  <p class="pp-card__label">Consentimento do titular</p>
                  <p class="pp-card__desc">
                    Para coleta e uso do número de telefone para fins de
                    comunicação e marketing
                  </p>
                </div>
              </div>
            </div>
          </article>

          <!-- 04 -->
          <article class="pp-section">
            <span class="pp-num">04</span>
            <div class="pp-body">
              <h2 class="pp-title">Armazenamento</h2>
              <ul class="pp-list">
                <li>
                  <strong>Imagens</strong> — armazenadas temporariamente em
                  ambiente seguro e excluídas automaticamente em até
                  <strong>24 horas</strong>.
                </li>
                <li>
                  <strong>Dados de contato</strong> — armazenados pelo período
                  necessário para cumprimento das finalidades informadas ou até
                  solicitação de exclusão pelo titular.
                </li>
              </ul>
            </div>
          </article>

          <!-- 05 -->
          <article class="pp-section">
            <span class="pp-num">05</span>
            <div class="pp-body">
              <h2 class="pp-title">Compartilhamento</h2>
              <div class="pp-callout">
                <p class="pp-callout__text">
                  <strong>Não comercializamos dados pessoais.</strong> O acesso
                  às informações é restrito à equipe técnica autorizada,
                  exclusivamente quando necessário para manutenção e operação do
                  sistema.
                </p>
              </div>
            </div>
          </article>

          <!-- 06 -->
          <article class="pp-section">
            <span class="pp-num">06</span>
            <div class="pp-body">
              <h2 class="pp-title">Direitos do titular</h2>
              <p class="pp-text">
                O usuário pode, a qualquer momento, solicitar:
              </p>
              <ul class="pp-list">
                <li>Acesso aos seus dados</li>
                <li>Correção de dados incompletos ou desatualizados</li>
                <li>Exclusão de seus dados</li>
              </ul>
              <div class="pp-contact">
                <p class="pp-contact__label">Canal de atendimento</p>
                <div class="pp-contact__links">
                  <span class="pp-contact__link">
                    <span class="pp-contact__icon">✉</span>
                    contato@photonow.com.br
                  </span>
                  <span class="pp-contact__link">
                    <span class="pp-contact__icon">↗</span>
                    (61) 98285-8561
                  </span>
                </div>
              </div>
            </div>
          </article>

          <!-- 07 -->
          <article class="pp-section pp-section--last">
            <span class="pp-num">07</span>
            <div class="pp-body">
              <h2 class="pp-title">Segurança da informação</h2>
              <p class="pp-text">
                Adotamos
                <strong>medidas técnicas e organizacionais</strong> para
                proteger os dados pessoais contra acessos não autorizados,
                perda, alteração ou divulgação indevida.
              </p>
            </div>
          </article>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
          <span class="modal-footer__brand">Photo Now</span>
          <span class="modal-footer__copy"
            >© {{ new Date().getFullYear() }} · Todos os direitos
            reservados</span
          >
          <button class="modal-btn-fechar" @click="$emit('input', false)">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "modalPoliticaPrivacidade",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inactivityTimer: null,
    };
  },
  watch: {
    value(isOpen) {
      if (isOpen) {
        this.resetInactivityTimer();
      } else {
        this.clearInactivityTimer();
      }
    },
  },
  beforeDestroy() {
    this.clearInactivityTimer();
  },
  methods: {
    resetInactivityTimer() {
      this.clearInactivityTimer();
      this.inactivityTimer = setTimeout(() => {
        this.$emit("input", false);
      }, 60000);
    },
    clearInactivityTimer() {
      if (this.inactivityTimer) {
        clearTimeout(this.inactivityTimer);
        this.inactivityTimer = null;
      }
    },
  },
};
</script>

<style scoped>
/* ── Overlay ─────────────────────────────────────────── */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(43, 36, 32, 0.72);
  z-index: 9000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
}

/* ── Container ───────────────────────────────────────── */
.modal-container {
  --accent: #d91a83;
  --accent-light: #f9e8f2;
  --bg: #f2ede8;
  --surface: #ede8e2;
  --surface-2: #e8e2dc;
  --border: #d4cdc5;
  --border-subtle: #dbd5ce;
  --txt-1: #2b2420;
  --txt-2: #4a403a;
  --txt-3: #8c7f76;

  background: var(--bg);
  font-family: "Rubik", "Source Serif 4", "Georgia", serif;
  font-weight: 300;
  color: var(--txt-1);
  border-radius: 0.75rem;
  width: min(680px, 100%);
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 24px 64px rgba(43, 36, 32, 0.35);
}

/* ── Header ──────────────────────────────────────────── */
.modal-header {
  padding: 1.75rem 2rem 1.25rem;
  border-bottom: 2px solid var(--txt-2);
  position: relative;
  flex-shrink: 0;
}

.modal-header__eyebrow {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 0.75rem;
}

.modal-brand {
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--accent);
}

.modal-sep {
  display: block;
  width: 1.25rem;
  height: 1px;
  background: var(--border);
}

.modal-tag {
  font-size: 0.6rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--txt-3);
}

.modal-title {
  font-family: "Rubik", "Playfair Display", "Georgia", serif;
  font-size: clamp(1.5rem, 3vw, 2rem);
  font-weight: 400;
  line-height: 1.15;
  letter-spacing: -0.02em;
  margin: 0 0 0.5rem;
  padding-right: 2.5rem;
}

.modal-meta {
  font-size: 0.75rem;
  color: var(--txt-3);
  margin: 0;
}

.modal-close {
  position: absolute;
  top: 1.25rem;
  right: 1.25rem;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  line-height: 1;
  border-radius: 0.375rem;
  transition: background 0.15s;
}

.modal-close:hover {
  background: var(--surface);
}

/* ── Body ────────────────────────────────────────────── */
.modal-body {
  overflow-y: auto;
  flex: 1;
  padding: 0 2rem;
}

/* ── Section ─────────────────────────────────────────── */
.pp-section {
  display: flex;
  gap: 1.25rem;
  padding: 1.5rem 0;
  border-bottom: 1px solid var(--border-subtle);
  align-items: flex-start;
}

.pp-section--last {
  border-bottom: none;
}

.pp-num {
  flex-shrink: 0;
  width: 2rem;
  font-size: 0.55rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  color: var(--accent);
  padding-top: 0.25rem;
}

.pp-body {
  flex: 1;
  min-width: 0;
}

.pp-title {
  font-family: "Rubik", "Playfair Display", "Georgia", serif;
  font-size: 1rem;
  font-weight: 700;
  color: var(--txt-1);
  margin: 0 0 0.6rem;
}

.pp-text {
  font-family: "Rubik", "Source Serif 4", "Georgia", serif;
  font-size: 0.9rem;
  font-weight: 300;
  line-height: 1.8;
  color: var(--txt-2);
  margin: 0;
}

.pp-text--mt {
  margin-top: 0.75rem;
}

.pp-text strong {
  color: var(--txt-1);
  font-weight: 700;
}

/* ── Lista ───────────────────────────────────────────── */
.pp-list {
  list-style: none;
  padding: 0;
  margin: 0.5rem 0 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.pp-list li {
  font-family: "Rubik", "Source Serif 4", "Georgia", serif;
  font-size: 0.9rem;
  font-weight: 300;
  line-height: 1.75;
  color: var(--txt-2);
  padding-left: 0.85rem;
  position: relative;
}

.pp-list li::before {
  content: "—";
  position: absolute;
  left: 0;
  font-size: 0.6rem;
  color: var(--accent);
  top: 0.3em;
}

.pp-list li strong {
  color: var(--txt-1);
  font-weight: 700;
}

/* ── Cards ───────────────────────────────────────────── */
.pp-cards {
  margin-top: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.pp-card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-left: 3px solid var(--accent);
  padding: 0.75rem 0.9rem;
}

.pp-card__label {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--txt-1);
  margin: 0 0 0.2rem;
}

.pp-card__desc {
  font-size: 0.78rem;
  color: var(--txt-2);
  line-height: 1.6;
  margin: 0;
}

/* ── Callout ─────────────────────────────────────────── */
.pp-callout {
  background: var(--accent-light);
  border-left: 3px solid var(--accent);
  padding: 0.85rem 1rem;
}

.pp-callout__text {
  font-family: "Rubik", "Source Serif 4", "Georgia", serif;
  font-size: 0.9rem;
  font-weight: 300;
  line-height: 1.8;
  color: var(--txt-2);
  margin: 0;
}

.pp-callout__text strong {
  color: var(--txt-1);
  font-weight: 700;
}

/* ── Contato ─────────────────────────────────────────── */
.pp-contact {
  margin-top: 1rem;
  border: 1px solid var(--border);
  overflow: hidden;
}

.pp-contact__label {
  display: block;
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--txt-3);
  padding: 0.55rem 0.9rem;
  border-bottom: 1px solid var(--border);
  background: var(--surface-2);
}

.pp-contact__links {
  display: flex;
  flex-direction: column;
}

.pp-contact__link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.82rem;
  color: var(--txt-1);
  padding: 0.65rem 0.9rem;
  border-bottom: 1px solid var(--border-subtle);
}

.pp-contact__link:last-child {
  border-bottom: none;
}

.pp-contact__icon {
  color: var(--txt-3);
  font-size: 0.75rem;
}

/* ── Footer ──────────────────────────────────────────── */
.modal-footer {
  border-top: 2px solid var(--txt-2);
  padding: 1rem 2rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-shrink: 0;
}

.modal-footer__brand {
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--accent);
}

.modal-footer__copy {
  font-size: 0.72rem;
  color: var(--txt-3);
  flex: 1;
}

.modal-btn-fechar {
  background: var(--accent);
  color: #fff;
  font-size: 0.875rem;
  font-weight: 600;
  padding: 0.5rem 1.5rem;
  border: none;
  border-radius: 0.375rem;
  cursor: pointer;
  transition: opacity 0.15s;
  flex-shrink: 0;
}

.modal-btn-fechar:hover {
  opacity: 0.88;
}

/* ── Transition ──────────────────────────────────────── */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter .modal-container,
.modal-fade-leave-to .modal-container {
  transform: translateY(12px);
  transition: transform 0.2s ease;
}
</style>
